import React, { Component } from 'react';
import UsefulLinks from '../../containers/UsefulLinks/UsefulLinks';

class UsefulLinksPage extends Component {
  render() {
    return <UsefulLinks />;
  }
}

export default UsefulLinksPage;
